import React from "react";

const Footer = () => {
  return (
    <footer className="w-full bg-[#0f0f0f] border-t border-[#1a1a1a] py-8 text-[13px] text-[#555555]">
      <div className="max-w-[1100px] mx-auto px-5 flex flex-col md:flex-row items-center justify-between gap-4">
        <div>
          © 2026 Harshit · Building in public
        </div>

        <div className="flex items-center space-x-6 flex-wrap justify-center">
          <a
            href="mailto:prajharshit@gmail.com"
            className="hover:text-[#999999] transition-colors"
          >
            Email
          </a>
          <a
            href="https://x.com/harshitpraj"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#999999] transition-colors"
          >
            Twitter
          </a>
          <a
            href="https://github.com/ha1rshit"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#999999] transition-colors"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/harshitpraj"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#999999] transition-colors"
          >
            LinkedIn
          </a>
          <a
            href="https://instagram.com/harshitpraj"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#999999] transition-colors"
          >
            Instagram
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
